import { HttpBackend, HttpClient, HttpParameterCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig, AppConfigUrl, AuthConfig } from 'app/models/auth-config';
import { AppConsts } from 'app/shared/services/app-const';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private appConfig: AppConfig;
  private http: HttpClient;

  constructor(private httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  public loadConfig(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http.get<AppConfig>('/api/configuration').subscribe(
        value => {
          this.appConfig = value;
          AppConsts.authConfig = this.appConfig.authConfig;
          AppConsts.webConfig = this.appConfig.appConfig;
          resolve(true);
        },
        error => {
          reject(error);
        },
      );
    });
  }

  getAppConfig() {
    return AppConsts.appConfig ? AppConsts.appConfig : this.appConfig;
  }

  public getAuthConfig(): AuthConfig {
    return AppConsts.authConfig ? AppConsts.authConfig : this.appConfig.authConfig;
  }

  public getWebConfig(): AppConfigUrl {
    return AppConsts.webConfig ? AppConsts.webConfig : this.appConfig.appConfig;
  }
}

export function getUrlFromDomainAndPath(domain: string, path: string) {
  if (domain.endsWith('/')) {
    domain = domain.slice(0, -1);
  }

  if (path.startsWith('/')) {
    path = path.substring(1);
  }

  return domain + '/' + path;
}

export class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
